"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterAndSortData = exports.initializeFilteredMetaData = exports.mapStateToProps = exports.changeToCurrentFolder = exports.changeFolder = exports.onSearchFiles = exports.clearSearchFileTypeClicked = exports.clearAllSearch = exports.toggleFile = exports.bookmarkAllFiles = exports.selectAllFiles = exports.isAllBookmarked = exports.isAllFilesSelected = exports.isSearchResultsToggled = exports.isAllFollowed = exports.hasPermissionToUpload = void 0;
var fp = require("fp-ts");
var permissions_1 = require("@caddigital/sok-reducers/lib/utils/permissions");
var filesReducer = require("@caddigital/sok-reducers/lib/reducers/files");
var translate_1 = require("utils/translate");
var viewport_1 = require("reducers/viewport");
var fileListFilter_1 = require("utils/helpers/fileListFilter");
var hasPermissionToUpload = function (folder) {
    return folder && folder.perm && folder.perm & permissions_1.ACL_WRITE ? true : false;
};
exports.hasPermissionToUpload = hasPermissionToUpload;
var isAllFollowed = function (props) {
    return props.data.status === 'FETCHED' &&
        props.filteredAndSortedItems.length > 0 &&
        props.filteredAndSortedItems.every(function (r) {
            return r.notifications ? r.notifications.email === true : false;
        });
};
exports.isAllFollowed = isAllFollowed;
var isSearchResultsToggled = function (props) {
    return ((props.searchOptions.searchString &&
        props.searchOptions.searchString !== '') ||
        (props.searchOptions.containsTermString &&
            props.searchOptions.containsTermString !== '') ||
        props.searchOptions.limitSearchToFolder.isSome() ||
        props.searchOptions.searchFileType.isSome() ||
        props.searchOptions.allVersions === true ||
        props.searchOptions.to !== null ||
        props.searchOptions.from !== null ||
        (props.searchOptions.meta !== null &&
            props.searchOptions.metaValue !== null));
};
exports.isSearchResultsToggled = isSearchResultsToggled;
var isAllFilesSelected = function (props) {
    return props.data.status === 'FETCHED' &&
        props.fileSelections.length > 0 &&
        props.filteredAndSortedItems.every(function (r) {
            return props.fileSelections.findIndex(function (f) { return r.uuid === f.uuid; }) > -1;
        });
};
exports.isAllFilesSelected = isAllFilesSelected;
var isAllBookmarked = function (props) {
    return props.data.status === 'FETCHED' &&
        props.filteredAndSortedItems.length > 0 &&
        props.filteredAndSortedItems.every(function (r) { return r.bookmarked === true; });
};
exports.isAllBookmarked = isAllBookmarked;
var selectAllFiles = function (props) { return function () {
    if ((0, exports.isAllFilesSelected)(props)) {
        props.onUnselectFileItems(props.filteredAndSortedItems);
    }
    else {
        props.onSelectFileItems(props.filteredAndSortedItems);
    }
}; };
exports.selectAllFiles = selectAllFiles;
var bookmarkAllFiles = function (props) { return function () {
    if ((0, exports.isAllBookmarked)(props)) {
        props.onUnBookmarkClick(props.filteredAndSortedItems.map(function (x) {
            return x.type === 'FOLDER' ? x.id : x.file;
        }));
    }
    else {
        props.onBookmarkClick(props.filteredAndSortedItems.map(function (x) {
            return x.type === 'FOLDER' ? x.id : x.file;
        }));
    }
}; };
exports.bookmarkAllFiles = bookmarkAllFiles;
var toggleFile = function (props) { return function (item) {
    var fileIsSelected = props.fileSelections.find(function (file) { return file.id === item.id; });
    if (fileIsSelected) {
        props.onUnselectFileItems([item]);
    }
    else {
        props.onSelectFileItems([item]);
    }
}; };
exports.toggleFile = toggleFile;
var clearAllSearch = function (props) { return function () {
    props.currentFolder !== null &&
        props.onFetchFiles(props.currentFolder.id, props.sortByOptions, __assign({}, filesReducer.defaultFileSearchOptions));
}; };
exports.clearAllSearch = clearAllSearch;
var clearSearchFileTypeClicked = function (props) { return function () {
    if (props.currentFolder === null) {
        return;
    }
    if (props.selectedFileType.isSome()) {
        props.onFetchFiles(props.currentFolder.id, props.sortByOptions, __assign(__assign({}, props.searchOptions), { searchFileType: fp.option.none }));
    }
}; };
exports.clearSearchFileTypeClicked = clearSearchFileTypeClicked;
var onSearchFiles = function (props) { return function (searchOptions) {
    if (searchOptions.limitSearchToFolder &&
        searchOptions.limitSearchToFolder.type === 'DEFINED' &&
        searchOptions.limitSearchToFolder.value.value) {
        return props.onFetchFiles(searchOptions.limitSearchToFolder.value.value, props.sortByOptions, searchOptions);
    }
    if (props.currentFolder !== null) {
        props.onFetchFiles(props.currentFolder.id, props.sortByOptions, searchOptions);
    }
}; };
exports.onSearchFiles = onSearchFiles;
var changeFolder = function (props, folderId) {
    if (props.searchOptions.toggleHideEmptyFolders === true) {
        props.onResetSortOptions();
        return props.onFetchFiles(folderId, __assign({}, filesReducer.initialSortByOptions), __assign(__assign({}, props.searchOptions), { searchString: '' }));
    }
    else
        props.onResetSortOptions();
    return props.onFetchFiles(folderId, __assign({}, filesReducer.initialSortByOptions), __assign({}, filesReducer.defaultFileSearchOptions));
};
exports.changeFolder = changeFolder;
var changeToCurrentFolder = function (props) { return function () {
    if (props.currentFolder) {
        (0, exports.changeFolder)(props, props.currentFolder.id);
    }
}; };
exports.changeToCurrentFolder = changeToCurrentFolder;
var mapStateToProps = function (router, files, viewport, bid, token, cart) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        router: router,
        properties: files.filesFolderProperties,
        fileSelections: files.selectedItems,
        fileList: files.fileList,
        viewportSize: viewport.size,
        data: files.data,
        folderPath: files.folderPath,
        currentFolder: files.currentFolder,
        bid: bid.current,
        // Searching
        searchOptions: files.searchOptions,
        searchData: files.searchData,
        // Toggled States
        filtersDropdownToggled: files.filtersDropdownToggled,
        columnsDropdownToggled: files.columnsDropdownToggled,
        sortDropdownToggled: files.sortDropdownToggled,
        cartToggled: cart.toggled,
        mobileSearchOverlayToggled: files.mobileSearchOverlayToggled,
        advancedSearchDropdownToggled: files.advancedSearchDropdownToggled,
        searchDropdownToggled: files.searchDropdownToggled,
        // Sorting
        sortByOptions: files.sortByOptions,
        cartSelectionsLength: cart.data.items.length,
        filesSelectionLength: files.data.status === 'FETCHED' ? files.selectedItems.length : 0,
        isFetching: files.data.status !== 'FETCHED' && files.data.status !== 'FAILED',
        isMobile: (0, viewport_1.isMobile)(viewport),
        selectedLanguage: selectedLanguage,
        token: token,
        selectedFileType: files.searchOptions.searchFileType,
        filtering: files.searchOptions.filtering,
        fileBrowser: files.fileBrowser
    };
};
exports.mapStateToProps = mapStateToProps;
var initializeFilteredMetaData = function (metadata, fileList, setMetaDataColumns) {
    var columns = (0, fileListFilter_1.filterMetadataColumns)(metadata.status === 'FETCHED' ? metadata.list : [], fileList.filteredMetadataColumns).sort(function (a, b) { return a.order - b.order; });
    setMetaDataColumns(columns);
};
exports.initializeFilteredMetaData = initializeFilteredMetaData;
var filterAndSortData = function (sortByOptions, searchOptions, metadataList, files, metaDataColumns, setTotalResults, setFilteredAndSortedItems) {
    var sorted = (0, fileListFilter_1.filterData)(metaDataColumns, files, sortByOptions, searchOptions, metadataList);
    var slice = sorted.slice(Math.max(0, Math.min(sorted.length, sortByOptions.offset)), Math.min(sortByOptions.offset + sortByOptions.limit, sorted.length));
    setTotalResults(sorted.length);
    setFilteredAndSortedItems(slice);
};
exports.filterAndSortData = filterAndSortData;
